<template>
  <div class="system-page" id="app">
    <mt-header :title="'我的'"> </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div style="width: calc(100% - 2rem); margin: 0px 1rem; margin-top: 15px">
      <div class="usermessage">
        <div class="userimg">
          <img :src="headFile" @error="imageErr" id="pic" />
        </div>
        <div class="userinfo">
          <div class="glyphicon glyphicon-user">{{ userInfo.userName }}</div>
          <div class="glyphicon glyphicon-tags" v-if="userInfo && userInfo.dept">
            {{ userInfo.dept.deptName }}
          </div>
        </div>
      </div>
<!--      <div class="userinfo">-->
<!--        <div class="useritem">-->
<!--          <div class="glyphicon glyphicon-th-list">姓名</div>-->
<!--          <div class="content">{{ userInfo.realName }}</div>-->
<!--        </div>-->
<!--        <div class="useritem">-->
<!--          <div class="glyphicon glyphicon-map-marker">任职公司</div>-->
<!--          <div class="content">{{ userInfo.companyName }}</div>-->
<!--        </div>-->
<!--        <div class="useritem">-->
<!--          <div class="glyphicon glyphicon-leaf">性别</div>-->
<!--          <div class="content">{{ userInfo.sex }}</div>-->
<!--        </div>-->
<!--        <div class="useritem">-->
<!--          <div class="glyphicon glyphicon-align-justify">身份证号</div>-->
<!--          <div class="content">{{ userInfo.idCard }}</div>-->
<!--        </div>-->
<!--&lt;!&ndash;        <div class="useritem">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="glyphicon glyphicon-envelope">Email</div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="content">{{ userInfo.eamil }}</div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div class="useritem">-->
<!--          <div class="glyphicon glyphicon-earphone">电话</div>-->
<!--          <div class="content">{{ userInfo.userTel }}</div>-->
<!--        </div>-->
<!--        <div class="useritem">-->
<!--          <div class="glyphicon glyphicon-bookmark">毕业院校</div>-->
<!--          <div class="content">{{ userInfo.school }}</div>-->
<!--        </div>-->
<!--        <div class="useritem">-->
<!--          <div class="glyphicon glyphicon-book">学历</div>-->
<!--          <div class="content">{{ userInfo.userEdu }}</div>-->
<!--        </div>-->
<!--        <div class="useritem">-->
<!--          <div class="glyphicon glyphicon-map-marker">地址</div>-->
<!--          <div class="content">{{ userInfo.address }}</div>-->
<!--        </div>-->
<!--      </div>-->
      <mt-button
          v-if="userInfo.realName"
          class="logoutBtn"
          @click.native="logout"
      >退出登录</mt-button>
      </div>
    <v-tab-module selected="我的" :messageNum="messageNum"></v-tab-module>
  </div>
</template>

<script>
import tabModule from "@/components/footerBar/index.vue";
import { getLocalData } from "@/utils/sessionData.js";
import picImg from "../../../assets/login-index/pic.png";
import request from "@/utils/keyCloakRequest";
export default {
  components: {
    "v-tab-module": tabModule,
  },
  beforeMount() {},
  data() {
    return {
      userInfo: {},
      isLoading: false,
      headFile: null,
      messageNum: 0
    };
  },
  created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    request({
      url: "image/"+this.userInfo.imgPath,
      method: "POST",
      responseType: 'blob'
    }).then(response => {
      const blob = new Blob([response], { type: 'image/jpeg' });
      this.headFile = URL.createObjectURL(blob);
    })

  },
  mounted() {
  },

  methods: {
    imageErr() {
      const pic = document.getElementById("pic");
      pic.setAttribute(
        "src",
        picImg
      );
    },
    logout() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 0.6rem;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}

body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.menuTitle {
  font-size: 1rem;
}
.system-page {
  width: 100%;
  height: 100vh;
  background-color: #f1f5f8;
  font-family: "PingFangSC-Regular";
}
.userinfo {
  margin-left: 1rem /* 30/16 */;
  height: 1rem;
  line-height: 1rem;
  .useritem {
    display: flex;
    justify-content: space-between;
    height: 2rem /* 60/16 */;
    line-height: 3.8rem /* 60/16 */;
    padding: 0 7px;
    border-bottom: 1px solid #eee;
    div {
      line-height: 2.8rem /* 60/16 */;
      font-size: 1rem;
      color: rgb(31, 30, 30);
    }
    .content {
      position: fixed;
      margin-left: 8rem;
      font-size: 1rem;
      color: rgb(31, 30, 30);
    }
    .label {
      margin-top: 1.3rem;
      font-size: 1rem;
      color: rgb(31, 30, 30);
    }
    .upload {
      display: flex;
      align-items: center;
      img {
        width: 2rem;
        height: 2rem;
        margin-right: 0.3rem;
      }
      div {
        font-size: 0.8rem;
      }
    }
  }
}
// 用户样式
.usermessage {
  margin-top: .5rem;
  display: flex;
  background: @color;
  padding: 1.25rem /* 40/16 */ 0 1.875rem /* 30/16 */ 1.25rem /* 20/16 */;
  border-radius: @border-rd;
  .userimg {
    img {
      width: 2.8rem /* 90/16 */;
      height: 2.8rem /* 90/16 */;
      border-radius: 50%;
    }
  }
  .userinfo {
    margin-left: 1rem /* 30/16 */;
    height: 2rem;
    line-height: 1rem;
    div{
      font-size: 1.2rem;
      font-weight: 700;
      height: 1rem;
      width: 10rem;
      line-height: 1rem;
      margin-bottom: 0.18rem;
    }
  }
}
.logoutBtn {
  width: 100%;
  height: 2.666667rem;
  line-height: 2.666667rem;
  font-size: 1rem;
  margin: 2rem auto;
  background: rgb(243, 77, 77);
  display: flex !important;
  justify-content: center;
  align-items: center;
  border-radius: 0.4rem;
  color: #fff;
  .mint-button-text {
    font-size: 1rem !important;
  }
}
/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
</style>
